// extracted by mini-css-extract-plugin
export default {"toggleTitle":"ReportCapabilities_toggleTitle__Ri3jE"};